import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/outline";
import { ExclamationIcon, XIcon } from "@heroicons/react/outline";
import { CIcon } from "@coreui/icons-react";
import { cifAU } from "@coreui/icons";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import AudioPlayer from "material-ui-audio-player";
import axios from "axios";
import { ToastContainer, toast } from "react-toast";
import { withTranslation } from "react-i18next";
import { useFormik } from "formik";
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;
function Deleterenvoiexterne(props) {
  const { t } = props;

  const [open, setOpen] = useState(false);
  const [contact, setcontact] = useState({});

  const [redirectToReferrer, setreff] = useState(false);
  const showCustom = () =>
    toast("Contact modifié  avec succès", {
      backgroundColor: "#27d0b2",
      color: "#ffffff",
    });
  function handleSubmit(e) {
    e.preventDefault();
    var lien = window.location.href;
    //console.log(lien);
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");
    // console.log("kien ici", var4[0]);
    var config = {
      headers: {
        Authorization: token,
      },
    };
    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/RenvoiInjoignabiliterExterneIPBXV3API?compte=${compte}&poste=${poste}&nbr_sonnerie=&action_appel_externe=0&destination_appel_externe=`,
        config
      )
      .then((res) => {
        // this.getAllcontact();
        // this.setState({ redirectToReferrer: true });
        props.toggle();
        console.log("yopiiiiiiiiiiiiiiii", res);
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  }

  return (
    <Transition.Root show={props.showModal} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-10 inset-0 overflow-y-auto"
        open={open}
        onClose={props.handleClose}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="dark:bg-gray-800 dark:text-white inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <button
                  type="button"
                  className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                  onClick={props.handleClose}
                >
                  <span className="sr-only">Close</span>
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div className="sm:flex sm:items-start">
                <div className="mt-2 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <Dialog.Title
                    as="h3"
                    className="dark:text-white text-lg leading-6 font-medium text-gray-900 mt-6"
                  >
                    {t("delete.externe.transfert")} {props.num} ?
                  </Dialog.Title>
                </div>
              </div>

              <div className="mt-4 sm:mt-0">
                <div className="mt-5 md:mt-0 md:col-span-1">
                  <div className="flex -px-8 -py-8 mt-8 ml-52 text-right bottom-0 right-0 sm:px-6">
                    <div className="px-2">
                      <button
                        value="Supprimer"
                        type="button"
                        onClick={props.handleClose}
                        className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none "
                      >
                        {t("annuler")}
                      </button>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <div className="px-2">
                        <input
                          value={t("delete")}
                          type="submit"
                          onClick={props.handleClose}
                          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none "
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
export default withTranslation("common")(Deleterenvoiexterne);
